import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const PUBLIC_PAGES = ["/login", "/reset-password", "/forgot-password"];
// Endpoint auth che NON devono scatenare un refresh (evita loop: login con
// password errata e refresh scaduto devono semplicemente fallire)
const NO_REFRESH = ["/auth/login", "/auth/refresh", "/auth/forgot-password", "/auth/reset-password"];

// Un solo refresh in volo alla volta: le richieste concorrenti lo condividono
let refreshInFlight = null;
const refreshOnce = () => {
  if (!refreshInFlight) {
    refreshInFlight = api.post("/auth/refresh").finally(() => { refreshInFlight = null; });
  }
  return refreshInFlight;
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const onPublicPage = PUBLIC_PAGES.some((p) => window.location.pathname.startsWith(p));
    const isNoRefresh = NO_REFRESH.some((u) => (cfg.url || "").includes(u));
    if (err.response?.status !== 401 || onPublicPage || isNoRefresh) {
      return Promise.reject(err);
    }
    if (cfg._retried) {
      // già ritentato dopo un refresh riuscito: la sessione è davvero scaduta
      window.location.href = "/login";
      return Promise.reject(err);
    }
    cfg._retried = true;
    try {
      await refreshOnce();        // access token scaduto (15 min): rinnova e ritenta
    } catch {
      window.location.href = "/login";
      return Promise.reject(err);
    }
    return api(cfg);
  }
);

export function formatApiError(e) {
  const d = e.response?.data?.detail;
  if (d == null) return e.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export default api;
